import React from 'react';

import { Pronoun } from '@bb/contacts';

import TagGroup, { TagGroupOption, TagGroupProps } from '../TagGroup';

export const PRONOUN_TAGS: Record<Pronoun, TagGroupOption<Pronoun>> = {
  [Pronoun['he/him']]: {
    label: 'He / Him',
    value: Pronoun['he/him'],
  },
  [Pronoun['co/cos']]: {
    label: 'Co / Cos',
    value: Pronoun['co/cos'],
  },
  [Pronoun['em/eir']]: {
    label: 'Em / Eir',
    value: Pronoun['em/eir'],
  },
  [Pronoun['en/ens']]: {
    label: 'En / Ens',
    value: Pronoun['en/ens'],
  },
  [Pronoun['she/her']]: {
    label: 'She / Her',
    value: Pronoun['she/her'],
  },
  [Pronoun['they/them']]: {
    label: 'They / Them',
    value: Pronoun['they/them'],
  },
  [Pronoun['yo/yos']]: {
    label: 'Yo / Yos',
    value: Pronoun['yo/yos'],
  },
  [Pronoun['ze/zir']]: {
    label: 'Ze / Zir',
    value: Pronoun['ze/zir'],
  },
  [Pronoun.other]: {
    label: 'Other',
    value: Pronoun.other,
  },
};

export type PronounTagsProps = Omit<TagGroupProps<Pronoun>, 'options'>;

const PronounTags: React.FC<PronounTagsProps> = props => (
    <TagGroup
      options={Object.values(PRONOUN_TAGS)}
      closeButtonColor="gray8"
      tagProps={{ color: 'default' }}
      {...props}
    />
  );

export default PronounTags;
